import React, { Suspense, useEffect,lazy } from 'react';
import { Navigate} from 'react-router-dom';

const Bzer = lazy(()=>import('./uzer').then(mod=>({default:mod.Bzer})));
const Uzer = lazy(()=>import('./uzer').then(mod=>({default:mod.Uzer})));

const Protex = ({ user, children }) => {
    
    useEffect(() => {
        import('./uzer');
      }, []);

    if (Object.keys(user).length === 0) {
        return <Navigate to='/' />;
    };

    return(
        <Suspense fallback={<div></div>}>
            {user.brand ? <Bzer/> : <Uzer/>}
        </Suspense>
    );
 
};

export default Protex;
